import { Result } from 'domain/types';

import PreviewAnalysisDataClient from 'use-case/analysis/data/preview/previewAnalysisDataClient';
import AnalysisDataCriteria from 'use-case/analysis/analysisCriteria';
import { AnalysisData } from 'domain/analysisData';

export type PreviewAnalysisDataResult = Result<AnalysisData>;
export type PreviewAnalysisData = (criteria: AnalysisDataCriteria) => Promise<PreviewAnalysisDataResult>;

export default (previewAnalysisClient: PreviewAnalysisDataClient): PreviewAnalysisData => (
    criteria: AnalysisDataCriteria
): Promise<PreviewAnalysisDataResult> => previewAnalysisClient(criteria);
